import {
  CREATE_USER_FAILURE,
  CREATE_USER_INIT,
  CREATE_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_INIT,
  GET_USER_SUCCESS,
  RESET_USER,
  UPDATE_USER_FAILURE,
  UPDATE_USER_INIT,
  UPDATE_USER_SUCCESS,
  UserActionTypes,
  UserState
} from "./types";

const initialState: UserState = {
  entity: {},
  isCreatingUser: false,
  successCreatingUser: false,
  errorCreatingUser: null,
  isUpdatingUser: false,
  successUpdatingUser: false,
  errorUpdatingUser: null,
  isGettingUser: false,
  successGettingUser: false,
  errorGettingUser: null
};

export default function userReducer(
  state = initialState,
  action: UserActionTypes
) {
  switch (action.type) {
    case CREATE_USER_INIT:
      return {
        ...state,
        isCreatingUser: true
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        isCreatingUser: false,
        entity: action.user ? action.user : {}
      };

    case CREATE_USER_FAILURE:
      return {
        ...state,
        isCreatingUser: false,
        errorCreatingUser: action.error
      };

    case UPDATE_USER_INIT:
      return {
        ...state,
        isUpdatingUser: true
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdatingUser: false,
        entity: action.user ? action.user : {}
      };

    case UPDATE_USER_FAILURE:
      return {
        ...state,
        isUpdatingUser: false,
        errorUpdatingUser: action.error
      };

    case GET_USER_INIT:
      return {
        ...state,
        isGettingUser: true
      };

    case GET_USER_SUCCESS:
      return {
        ...state,
        isGettingUser: false,
        successGettingUser: true,
        entity: action.data ? action.data : {}
      };

    case GET_USER_FAILURE:
      return {
        ...state,
        isGettingUser: false,
        errorGettingUser: action.error
      };

    case RESET_USER:
      return initialState;

    default:
      return state;
  }
}
